import { Component, OnInit } from '@angular/core';
import { flatMap } from 'rxjs/operators';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { AppSettings } from 'src/app/utils/app-settings';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { Parent } from '../../../../../models/parent';
import { ProfileInfo } from '../../../../../models/profile-info';
import { LoaderService } from '../../../../../services/loader/loader.service';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { UserService } from '../../../../../services/user/user-service/user.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { PickupAssistant } from '../../../profile/models/pickup-assistant';
import { StudentProfileInfo } from '../../../profile/models/student-profile-info';
import { PickupAssistantService } from '../../../profile/services/pickup-assistant.service';
import { StudentProfileService } from '../../../profile/services/student-profile.service';
import { IdCardRequest } from '../../models/id-card-info';
import { IdCardService } from '../../services/id-card-service/id-card.service';
import { RateService } from 'rate';
import { EmergencyContactService } from '../../../profile/services/emergency-contact.service';
import { EmergencyContact } from '../../../profile/models/emergency-contact';

@Component({
  selector: 'app-id-card',
  templateUrl: './id-card.component.html',
  styleUrls: ['./id-card.component.scss']
})
export class IdCardComponent extends ComponentBase implements OnInit {

  constructor(private userService: UserService
    , private studentProfileService: StudentProfileService
    , private loaderService: LoaderService
    , private idCardService: IdCardService
    , private pickupAssistantService: PickupAssistantService
    , private emergencyContactService: EmergencyContactService
    , private routingService: RoutingService
    , private rateService: RateService
    , private pageHeadingService: PageHeadingService) {
    super();
  }

  profileInfo: ProfileInfo;
  studentProfileInfo: StudentProfileInfo;
  userInfo: Parent;
  isValid: boolean = true;
  isSubmitted: boolean = false;
  errorMsg: string;
  idCardRequest: IdCardRequest = <any>{};
  emergency_contact: EmergencyContact;
  pickupAssistants: Array<PickupAssistant> = [];
  pickup_force_reload = false;
  emgContact_force_reload = false;
  pickupImageUrl = `${AppSettings.apiUrl}pickupassistant/###/photo`
  emgContactImageUrl = `${AppSettings.apiUrl}emergencycontact/###/photo`

  ngOnInit() {
    this.pickup_force_reload = this.pickupAssistantService.force_reload_photo;
    this.emgContact_force_reload = this.emergencyContactService.force_reload_photo;
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("ID Card"));
    this.loaderService.requestStart();
    let subscription = this.userService.getLoggedInUser().pipe(
      flatMap(res => {
        this.profileInfo = res;
        return this.studentProfileService.getProfileInfo();
      })
    )
      .subscribe(res => {
        this.studentProfileInfo = res;
        this.userInfo = this.studentProfileInfo.parents_info.find(o => o.person_id == this.profileInfo.person.person_id);
        this.loaderService.requestComplete();
      });
    this.addSubscription(subscription);

    let sub2 = this.idCardService.getIdCardStatus()
      .subscribe((request) => {
        this.setCurrentRequest(request.result);
      });
    this.addSubscription(sub2);

    let sub3 = this.pickupAssistantService.getPickupAssistantsForStudent()
      .subscribe((res) => {
        this.pickupAssistants = res;
      });
    this.addSubscription(sub3);

    let sub4 = this.emergencyContactService.getEmergencyContactForStudent()
      .subscribe((res) => {
        this.emergency_contact = res;
      });
    this.addSubscription(sub4);
  }
  setCurrentRequest(request: IdCardRequest) {
    this.idCardRequest = request;
  }

  apply() {
    this.isSubmitted = true;
    if (this.isValid) {
      let sub = this.idCardService.apply()
        .subscribe((res) => {
          this.setCurrentRequest(res.result);
          this.rateService.showRate();
        });
      this.addSubscription(sub);
    }
  }

  setInvalid(msg: string) {
    this.isValid = false;
    this.errorMsg = "Please upload " + msg + " photo in profile page";
  }

  editProfileClicked() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'my-account', 'user'];
    this.routingService.navigate(route);
  }
  editPickup() {
    let route = new PrifactRoute();
    route.url = '/pages/my-account/student?suboption=14'
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }
  editEmgContact() {
    let route = new PrifactRoute();
    route.url = '/pages/my-account/student?suboption=15'
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }
}
